import { UserStatusTypes } from "types"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { type RootState } from "../store"

export type UserInfo = {
  username: string
  displayName: string
  groups: string[]
  legacyMerchantId?: string
  merchantId: string
  status: UserStatusTypes
}

export interface IUserState {
  userInfo: UserInfo
  customPhoto: string | null
}

const initialState: IUserState = {
  userInfo: {
    username: "",
    displayName: "",
    groups: [],
    merchantId: "",
    status: UserStatusTypes.NEW,
  },
  customPhoto: null,
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<Pick<IUserState, "userInfo">>) => {
      state.userInfo = action.payload.userInfo
    },
    setUserStatus: (state, action: PayloadAction<UserStatusTypes>) => {
      state.userInfo.status = action.payload
    },
    clearUserInfo: (state) => {
      state.userInfo = {
        ...initialState.userInfo,
        groups: [],
      }
    },
    setCustomPhoto: (state, action: PayloadAction<string | null>) => {
      state.customPhoto = action.payload
    },
  },
})

export const { setUserInfo, clearUserInfo, setUserStatus, setCustomPhoto } = userSlice.actions

export const selectUser = (state: RootState) => state.user
export const selectUserInfo = (state: RootState) => state.user.userInfo

export default userSlice.reducer
